import { useCallback, memo } from 'react';
import Card from '@shared/components/cards-list/Card';
import CardImage from '@shared/components/cards-list/CardImage';
import CardContent from '@shared/components/cards-list/CardContent';
import CardTitle from '@shared/components/cards-list/CardTitle';

const Product = ({
  className,
  item,
  controls,
  onClick,
}) => {
  const handleClick = useCallback((evt) => {
    onClick(item, evt);
  }, [onClick, item]);

  return (
    <Card
      className={ className }
      onClick={ handleClick }
      transparent={ item.hidden }
    >
      {controls}
      <CardImage
        src={ item.images[0]?.src }
        alt="model"
        variant="stretch"
        withPlaceholder
      />
      <CardContent>
        <CardTitle>
          {item.name.length < 20 ? item.name : `${item.name.substr(0, 20)}...`}
        </CardTitle>
      </CardContent>
    </Card>
  );
};

export default memo(Product);
